module.exports = {
    // 延安市食品监管云平台
    title: '逸农云',
  
    // 图片上传地址
    uploadUrl: process.env.VUE_APP_BASE_API + '/base/file/upload',
    openUploadUrl: process.env.VUE_APP_BASE_API + '/api/file/upload',
    imgUrl: process.env.VUE_APP_IMAGE_API,
  }